import {
  faCheck,
  faExclamation,
  faEye,
  faInfo,
  faTimes,
  type IconDefinition
} from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import clsx from 'clsx'
import { type PropsWithChildren, type ReactElement, useState } from 'react'
import {
  alertBase,
  alertClose,
  alertCloseVariations,
  alertIcon,
  alertIconVariations,
  alertMain,
  alertMainTitle,
  alertVariations
} from '~/components/Global/Interactions/Alert/Alert.css'
import { AlertVariation } from '~/components/Global/Interactions/Alert/AlertVariation'

const Icon = ({ variation }: { variation: AlertVariation }) => {
  if (
    variation === AlertVariation.Primary ||
    variation === AlertVariation.Secondary
  ) {
    return <FontAwesomeIcon icon={faEye} />
  }
  if (variation === AlertVariation.Info) {
    return <FontAwesomeIcon icon={faInfo} />
  }
  if (variation === AlertVariation.Success) {
    return <FontAwesomeIcon icon={faCheck} />
  }
  if (
    variation === AlertVariation.Danger ||
    variation === AlertVariation.Warning
  ) {
    return <FontAwesomeIcon icon={faExclamation} />
  }
}

export const Alert = ({
  message = '',
  icon,
  variation = AlertVariation.Primary,
  onDismiss,
  dismissId,
  children
}: PropsWithChildren<{
  message?: string | ReactElement
  icon?: IconDefinition
  variation: AlertVariation
  onDismiss?: (() => void) | false
  dismissId?: string
}>) => {
  const [isClosed, setIsClosed] = useState(
    dismissId
      ? localStorage.getItem(`alert_dismiss_${dismissId}`) !== null
      : false
  )

  if (isClosed) {
    return null
  }

  return (
    <div className={clsx(alertBase, alertVariations[variation])}>
      <div className={clsx(alertIcon, alertIconVariations[variation])}>
        {icon ? (
          <FontAwesomeIcon icon={icon} />
        ) : (
          <Icon variation={variation} />
        )}
      </div>
      <div className={alertMain}>
        {message && <div className={alertMainTitle}>{message}</div>}
        <div>{children}</div>
      </div>
      {onDismiss !== false && (
        <button
          type="button"
          onClick={() => {
            setIsClosed(true)
            if (dismissId) {
              localStorage.setItem(`alert_dismiss_${dismissId}`, 'true')
            }
            onDismiss?.()
          }}
          className={clsx(alertClose, alertCloseVariations[variation])}
        >
          <FontAwesomeIcon icon={faTimes} />
        </button>
      )}
    </div>
  )
}
